/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });


 
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *

 
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));

 */


/* Product carousel viewport-resize on image load.
   Flickity måler cell-højder ved init. For async-indlæste sektioner
   (product-recommendations, recently-viewed-products) sker init før billeder
   har størrelse → viewport kollapser til 0px. Vi kalder Flickity.resize()
   når hvert billede er færdigloadet, så viewport vokser til højeste cell. */
(function () {
  function resizeFlickity(carousel) {
    if (!window.Flickity || !Flickity.data) return;
    var flkty = Flickity.data(carousel);
    if (flkty && typeof flkty.resize === 'function') {
      try { flkty.resize(); } catch (e) {}
    }
  }

  // Sætter alle kort i et carousel til højde af det højeste. Gælder ALLE bredder:
  // låsen på 1008 px betød at telefon og tablet aldrig blev udlignet (målt 24/8 2026:
  // 76 px forskel ved 390 px, 24 px ved 900 px). Tilsvarende lås i theme.css er væk.
  function equalizeHeights(carousel) {
    var items = carousel.querySelectorAll('.Carousel__Cell > .ProductItem');
    if (!items.length) return;
    items.forEach(function (item) { item.style.minHeight = ''; });
    var max = 0;
    items.forEach(function (item) {
      var h = item.getBoundingClientRect().height;
      if (h > max) max = h;
    });
    if (max > 0) {
      items.forEach(function (item) { item.style.minHeight = max + 'px'; });
      resizeFlickity(carousel);
    }
  }

  function resizeAndEqualize(carousel) {
    resizeFlickity(carousel);
    equalizeHeights(carousel);
  }

  function bindCarousel(carousel) {
    if (carousel.dataset.dpResizeBound === '1') return;
    carousel.dataset.dpResizeBound = '1';
    var imgs = carousel.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (img.complete && img.naturalHeight > 0) return;
      var handler = function () { resizeAndEqualize(carousel); };
      img.addEventListener('load', handler, { once: true });
      img.addEventListener('error', handler, { once: true });
    });
    // Fang allerede-cachede billeder + giv Flickity et øjeblik til at initialisere
    setTimeout(function () { resizeAndEqualize(carousel); }, 50);
    setTimeout(function () { resizeAndEqualize(carousel); }, 500);
    setTimeout(function () { resizeAndEqualize(carousel); }, 1500);
  }

  function bindAll(root) {
    (root || document).querySelectorAll('.ProductList--carousel').forEach(bindCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindAll(); });
  } else {
    bindAll();
  }

  // Async-indlæste sections (Shopify section_id endpoint): observer for injected carousels
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.ProductList--carousel')) {
            bindCarousel(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.ProductList--carousel').forEach(bindCarousel);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Theme editor: hvis en section reloades, re-bind
  document.addEventListener('shopify:section:load', function (e) {
    bindAll(e.target);
  });

  // Lazysizes: når et lazy-loaded billede er færdig, find dets carousel og resize+equalize
  document.addEventListener('lazyloaded', function (e) {
    if (!e.target || !e.target.closest) return;
    var carousel = e.target.closest('.ProductList--carousel');
    if (carousel) resizeAndEqualize(carousel);
  }, true);

  // Re-equalize ved window resize (breakpoint-skift, fontsize-ændring m.m.)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.ProductList--carousel').forEach(resizeAndEqualize);
    }, 150);
  });
})();
